import { SpinningLoader } from "risa-oasis-ui_v2";
import { SftpSummaryTableDataModel } from "../../../../data-model/sftpSummaryTableDataModel";
import { SideNavId } from "../../../../enums/StringLiterals/sideNavId";
import { TableNames } from "../../../../enums/tableNames";
import CustomTable from "../../../custom-table/custom-table";
import {
  generateResponseStatusTableData,
  generateTextNotesTableData,
} from "../utils/sftpSummaryTableDataGenerator";

interface SftpSummaryContentProps {
  selectedTab: string;
  tableData: SftpSummaryTableDataModel[];
  loading: boolean;
  showInlineLoader: boolean;
  error: Error | null;
  totalCount: number;
  setEndIndex: (index: number) => void;
}

const SftpSummaryContent = ({
  selectedTab,
  tableData,
  loading,
  showInlineLoader,
  error,
  totalCount,
  setEndIndex,
}: SftpSummaryContentProps) => {
  const getTableHeaders = () => {
    return selectedTab === SideNavId.SFTP_SUMMARY_RESPONSE_STATUS
      ? generateResponseStatusTableData()
      : generateTextNotesTableData();
  };

  const getTableName = () => {
    return selectedTab === SideNavId.SFTP_SUMMARY_RESPONSE_STATUS
      ? TableNames.SFTP_SUMMARY_RESPONSE_STATUS_TABLE
      : TableNames.SFTP_SUMMARY_TEXT_NOTES_TABLE;
  };

  if (loading && tableData.length === 0) {
    return (
      <div className="flex h-full items-center justify-center gap-2">
        <SpinningLoader />
        <span>Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-500">
        Error loading SFTP summary: {error.message}
      </div>
    );
  }

  return (
    <CustomTable
      tableHeaders={getTableHeaders()}
      tableData={tableData}
      tableName={getTableName()}
      itemsPerPage={10}
      pagesPerView={4}
      hideSearchBar={true}
      count={totalCount}
      totalCount={totalCount}
      endIndexOfTable={setEndIndex}
      showInLineLoader={showInlineLoader}
    />
  );
};

export default SftpSummaryContent;
